<template>
  <div class="groups">
    <default-group
      :default-group="defaultGroup"
      :first-group="firstGroup"
    ></default-group>
    <draggable
      v-model="groups"
      group="groups"
      @start="drag = true"
      @end="drag = false"
      handle=".handle"
    >
      <div
        v-for="(group, index) in groups"
        :key="`group${index}`"
        class="group-item"
      >
        <group
          :group="group"
          :index="index"
          :blocks="group.blocks"
          @copy="getGroups"
        >
        </group>
        <!-- <div class="group-btn">
          <v-btn @click="emitCopyGroup(index)" fab small color="">
            <v-icon color="#666">content_copy</v-icon>
          </v-btn>
          <v-btn class="handle" fab small color="">
            <span
              class="botter-move-icon"
              style="font-size: 130%; color: #666"
            />
          </v-btn>
          <v-btn
            v-if="group.blocks && !group.blocks.length"
            @click="openDeleteDialog(group)"
            fab
            small
            color=""
          >
            <v-icon color="#666">delete_outline</v-icon>
          </v-btn>
        </div> -->
      </div>
    </draggable>
    <v-dialog v-model="dialog" width="500">
      <delete-dialog
        :title="`group ${toDelete.title}`"
        @closeDialog="dialog = false"
        @onDelete="deleteGroup"
      ></delete-dialog>
    </v-dialog>
    <div class="text-xs-center">
      <v-btn
        large
        color="white"
        class="primary--text text-bold"
        @click="addNewGroup"
      >
        <v-icon>add_circle</v-icon>
        Add New Group
      </v-btn>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import draggable from "vuedraggable";
import deleteDialog from "../../common/deleteDialog";
import defaultGroup from "./default-group";
import group from "./group";
export default {
  name: "groups",
  components: {
    defaultGroup,
    group,
    draggable,
    deleteDialog,
  },
  data() {
    return {
      groups: [],
      defaultGroup: [],
      firstGroup: [],
      toDelete: "",
      dialog: false,
    };
  },
  async mounted() {
    await this.getGroups();
    await this.getDefaultGroup();
    this.$root.$on("delete-group", (payload) => {
      let index = _.findIndex(this.groups, (o) => {
        return payload.id === o.id;
      });
      this.groups.splice(index, 1);
    });
  },
  methods: {
    async getGroups() {
      const response = await this.$http_bot("/groups");

      this.groups = response.data;
      for (let i = 0; i < this.groups.length; i++) {
        if (this.groups[i].blocks === null) {
          this.groups[i].blocks = [];
        }
      }
    },
    async getDefaultGroup() {
      this.$store.dispatch("setLoader", true);
      const response = await this.$http_bot(`/blocks?group_id=0`);
      this.$store.dispatch("setLoader", false);
      for (let i = 0; i < response.data.length; i++) {
        if (
          response.data[i].slug === "welcome-message" ||
          response.data[i].slug === "default-message" ||
          response.data[i].slug === "attachment-message" ||
          response.data[i].slug === "restart-message"
        ) {
          this.defaultGroup.push(response.data[i]);
        } else {
          this.firstGroup.push(response.data[i]);
        }
      }
      this.$store.dispatch("setSelectedBlock", this.defaultGroup[0]);
    },
    async getBlocks() {
      this.$store.dispatch("setLoader", true);
      const response = await this.$http_bot("/blocks");
      this.$store.dispatch("setLoader", false);
      for (let i = 0; i < response.data.length; i++) {
        if (response.data[i].group_id === 0) {
          if (
            response.data[i].name === "Welcome Message" ||
            response.data[i].name === "Default Message"
          ) {
            this.defaultGroup.push(response.data[i]);
          } else {
            this.firstGroup.push(response.data[i]);
          }
        } else {
          let index = _.findIndex(this.groups, (o) => {
            return response.data[i].group_id === o.id;
          });
          this.groups[index].blocks.push(response.data[i]);
        }
      }
    },
    async addNewGroup() {
      this.$store.dispatch("setSavingStatus", true);
      this.$store.dispatch("setLoader", true);
      const response = await this.$http.post(`/groups?bot_id=${this.botId}`, {
        bot_id: this.botId,
        order: this.groups.length + 1,
        title: `New Group ${this.groups.length + 1}`,
      });
      this.$store.dispatch("setLoader", false);
      let gp = response.data;
      if (!gp.blocks) gp.blocks = [];
      this.groups.push(gp);
      this.$store.dispatch("setSavingStatus", false);
    },
    async openDeleteDialog(group) {
      this.dialog = true;
      this.toDelete = group;
    },
    async emitCopyGroup(index) {
      //   console.log("em", index);
      this.$root.$emit("copy-group", index);
    },
    async deleteGroup() {
      this.$store.dispatch("setSavingStatus", true);
      this.$store.dispatch("setLoader", true);
      await this.$http.delete(`/groups/${this.toDelete.id}`);

      this.$store.dispatch("setLoader", false);
      this.$store.dispatch("setSavingStatus", false);
      this.dialog = false;
      let index = _.findIndex(this.groups, (o) => {
        return this.toDelete.id === o.id;
      });
      this.groups.splice(index, 1);
      this.toDelete = {};
    },
    async deleteBlock() {
      this.$store.dispatch("setSavingStatus", true);
      this.$store.dispatch("setLoader", true);
      let index = -1;
      let groupIndex = -1;
      await this.$http.delete(`/blocks/${this.deletedBlock.id}`);

      if (this.deletedBlock.group_id === 0) {
        index = _.findIndex(this.firstGroup, (o) => {
          return o.id === this.deletedBlock.id;
        });
        this.firstGroup.splice(index, 1);
        this.$store.dispatch(
          "setSelectedBlock",
          this.firstGroup[this.firstGroup.length - 1]
        );
      } else {
        groupIndex = _.findIndex(this.groups, (o) => {
          return o.id === this.deletedBlock.group_id;
        });
        index = _.findIndex(this.groups[groupIndex].blocks, (o) => {
          return o.id === this.deletedBlock.id;
        });
        this.groups[groupIndex].blocks.splice(index, 1);
        if (this.groups[groupIndex].blocks.length) {
          this.$store.dispatch(
            "setSelectedBlock",
            this.groups[groupIndex].blocks[
              this.groups[groupIndex].blocks.length - 1
            ]
          );
        } else {
          this.$store.dispatch("setSelectedBlock", this.defaultGroup[0]);
        }
      }
      this.$store.dispatch("setDeletedBlock", {});
      this.$store.dispatch("setLoader", false);
      this.$store.dispatch("setSavingStatus", false);
    },
  },
  computed: {
    botId() {
      return this.$store.state.bot.botId;
    },
    deletedBlock() {
      return this.$store.state.blocksBuild.deletedBlock;
    },
  },
  watch: {
    deletedBlock(state) {
      if (state.id) {
        this.deleteBlock();
      }
    },
  },
};
</script>

<style scoped>
.groups {
  height: calc(100vh - 250px);
  overflow: auto;
}
</style>
